module.exports = __webpack_public_path__ + "static/media/bbq.d9375014.jpg";